import { useState } from "react";
import { Selector } from "../common";
import { horseService } from "./HorseService.js";



function HorseSelector({
    onChange,
    ...props
}) {
    const [suggestions, setSuggestions] = useState(null)

    function handleSelectorInputChange(value) {
        horseService.indexHorses({
            sortOrder: null,
            searchString: value,
            pageSize: 10,
            pageNumber: 1
        })
        .then(response => setSuggestions(response.data.entities))
        .catch(error => console.error(error));
    }

    function handleSelectorValueChange(value) {
       
       // console.log(value)
        onChange(value);
    }

    function formatHorseString(horse) {
        return horse?.name ?? "";
    }

    return (
        <Selector {...props} 
        onInputChange={handleSelectorInputChange} 
        onValueChange={handleSelectorValueChange} 
        itemStringExtractor={formatHorseString} suggestedItems={suggestions}></Selector>
    );
}

export default HorseSelector;